/**
 * Renders the search input component.
 *
 * @param {Object}   props               - The properties object.
 * @param {string}   props.searchTerm    - Current search term.
 * @param {Function} props.setSearchTerm - Function to update search term.
 *
 * @return { JSX.Element } Rendered search input component.
 */
const Search = ( { searchTerm, setSearchTerm } ) => {
	return (
		<input type="search" value={ searchTerm } aria-label="Search" className="product-lookup__search" onChange={ e => setSearchTerm( e.target.value ) } placeholder={ window.wp.i18n.__( 'Search…', 'ac-product-lookup' ) } />
	);
};

export default Search;
